module.exports = __webpack_public_path__ + "img/29ad992.png";